import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const DigilockerStatusInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-folder', title: 'Digilocker Status', subtitle: 'Check the status of an existing Digilocker session' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'digilocker_xxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            method: 'GET',
            path: '/surepass/digilocker/status',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="digilocker-status"
        submitLabel="Check Status"
        successSummary="Digilocker status fetched"
        errorSummary="Status check failed"
        confirmHeader="Confirm Digilocker status check"
        confirmAcceptLabel="Yes, check"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Digilocker Status', icon: 'pi-folder' }}
    />
);

export default DigilockerStatusInputComponent;
